import { Theme } from '@mui/material';

import { createStyles, makeStyles } from '@mui/styles';

export const styles = makeStyles((theme: Theme) =>
  createStyles({
    presenter: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 9999,
      backgroundColor: theme.palette.common.white,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: 'none',
    },
    alignCenter: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  }),
);
